import { useState, useEffect } from "react";
import { Provider } from "react-redux";
import MainRoutes from "./routes";
import { store } from "./redux/storeOf";
import "./App.css";
import { Result, Button, Card, Row, Col, Space, Tag, Divider } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { useAxiosSessionInterceptor } from "./utils/useAxiosSessionInterceptor";
import { useIdleTimer } from "react-idle-timer";

const PLATFORM_REQUIREMENTS = {
  macOS: {
    viewport: { width: 1440, height: 900 },
    scaled: { width: 1440, height: 900 },
    description: 'MacBook 13" or larger',
  },
  windows: {
    viewport: { width: 1366, height: 600 },
    scaled: { width: 1366, height: 600 },
    description: "Standard HD laptop or larger",
  },
  default: {
    viewport: { width: 1280, height: 600 },
    scaled: { width: 1280, height: 600 },
    description: "Standard desktop display",
  },
};

function App() {
  // useAxiosSessionInterceptor();
  const [isResolutionSufficient, setIsResolutionSufficient] = useState(true);
  const [debugInfo, setDebugInfo] = useState(null);

  const checkResolution = () => {
    const dpr = window.devicePixelRatio || 1;

    // viewport for CSS pixels
    const vw = window.innerWidth;
    const vh = window.innerHeight;

    // OS-scaled / Hi-DPI effective resolution
    const scaledW = Math.round(vw * dpr);
    const scaledH = Math.round(vh * dpr);

    // Physical available screen space
    const sw = window.screen?.width;
    const sh = window.screen?.height;

    // Determine platform baseline
    const isMac = navigator.platform.toUpperCase().includes("MAC");
    const isWindows = navigator.platform.toUpperCase().includes("WIN");

    let platform = "default";
    if (isMac) platform = "macOS";
    else if (isWindows) platform = "windows";

    const requirements = PLATFORM_REQUIREMENTS[platform];

    console.log(`Platform detected: ${platform}`);
    console.log(
      `DPR: ${dpr}, VW: ${vw}, VH: ${vh}, ScaledW: ${scaledW}, ScaledH: ${scaledH}, SW: ${sw}, SH: ${sh}`,
    );

    const meetsViewportReq =
      vw >= requirements.viewport.width && vh >= requirements.viewport.height;

    const meetsScaledReq =
      scaledW >= requirements.scaled.width && scaledH >= requirements.scaled.height;

    const meetsScreenReq = sw >= requirements.scaled.width && sh >= requirements.scaled.height;

    const ok = meetsViewportReq && meetsScreenReq;
    // const ok = meetsViewportReq && meetsScaledReq && meetsScreenReq;
    console.log(meetsViewportReq, meetsScaledReq, meetsScreenReq, ok);
    setIsResolutionSufficient(ok);

    setDebugInfo({
      vw,
      vh,
      dpr,
      scaledW,
      scaledH,
      sw,
      sh,
      meetsViewportReq,
      // meetsScaledReq,
      meetsScreenReq,
      platform,
      requirements,
    });
  };

  useEffect(() => {
    checkResolution();

    window.addEventListener("resize", checkResolution);
    window.addEventListener("orientationchange", checkResolution);

    // Browser zoom affects viewport metrics differently
    window.matchMedia("(resolution)").addEventListener("change", checkResolution);

    return () => {
      window.removeEventListener("resize", checkResolution);
      window.removeEventListener("orientationchange", checkResolution);
      window.matchMedia("(resolution)").removeEventListener("change", checkResolution);
    };
  }, []);

  // BEGIN IDLE LOGIC

  const handleOnIdle = (event) => {
    console.log("last active", getLastActiveTime());

    window.location.href = "/sign-in";
  };

  const handleOnActive = (event) => {
    console.log("user is active", event);
    console.log("time remaining", getRemainingTime());
  };

  const handleOnAction = (event) => {
    console.log("user did something", event);
  };
  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: 300_000,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    onAction: handleOnAction,
    debounce: 250,
  });
  // END IDLE LOGIC

  // if (!isResolutionSufficient) {
  //   return (
  //     <div
  //       style={{
  //         minHeight: "100vh",
  //         display: "flex",
  //         alignItems: "center",
  //         justifyContent: "center",
  //         // background: "linear-gradient(135deg, #f5f7fa 0%, #e4e9f2 100%)",
  //         padding: "10px",
  //       }}
  //     >
  //       <Card
  //         style={{
  //           maxWidth: 700,
  //           width: "100%",
  //           borderRadius: 16,
  //           boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
  //         }}
  //       >
  //         <Result
  //           status="warning"
  //           style={{
  //             padding: "0px",
  //           }}
  //           title="Display Requirements Not Met"
  //           subTitle={`This application is optimized for ${debugInfo?.requirements?.description} with minimum resolution of ${debugInfo?.requirements?.viewport.width}×${debugInfo?.requirements?.viewport.height}.`}
  //         />

  //         <Divider>System Information</Divider>

  //         <Space direction="vertical" size="middle" style={{ width: "100%" }}>
  //           {/* Platform Info */}
  //           <Card size="small" style={{ background: "#fafafa" }}>
  //             <Space>
  //               <div>
  //                 <div style={{ fontWeight: 600, fontSize: 14 }}>Platform</div>
  //                 <div style={{ color: "#666", fontSize: 13 }}>
  //                   {debugInfo?.platform === "macOS" && "macOS"}
  //                   {debugInfo?.platform === "windows" && "Windows"}
  //                   {debugInfo?.platform === "default" && "Other"}
  //                   {" • "}
  //                   {debugInfo?.dpr}x Display Scaling
  //                 </div>
  //               </div>
  //             </Space>
  //           </Card>

  //           {/* Requirements Check */}
  //           <Row gutter={[12, 12]}>
  //             <Col span={24}>
  //               <Card
  //                 size="small"
  //                 style={{
  //                   background: debugInfo?.meetsViewportReq
  //                     ? "#f6ffed"
  //                     : "#fff2e8",
  //                   borderColor: "none",
  //                 }}
  //               >
  //                 <Space>
  //                   {debugInfo?.meetsViewportReq ? (
  //                     <CheckCircleOutlined
  //                       style={{ fontSize: 20, color: "#52c41a" }}
  //                     />
  //                   ) : (
  //                     <CloseCircleOutlined
  //                       style={{ fontSize: 20, color: "#ff7a45" }}
  //                     />
  //                   )}
  //                   <div style={{ flex: 1 }}>
  //                     <div style={{ fontWeight: 600, fontSize: 13 }}>
  //                       Viewport Size
  //                     </div>
  //                     <div
  //                       style={{ color: "#666", fontSize: 12, marginTop: 4 }}
  //                     >
  //                       Current: {debugInfo?.vw} × {debugInfo?.vh} pixels
  //                     </div>
  //                     <div style={{ color: "#999", fontSize: 11 }}>
  //                       Required: {debugInfo?.requirements?.viewport.width} ×{" "}
  //                       {debugInfo?.requirements?.viewport.height} pixels
  //                     </div>
  //                   </div>
  //                   {debugInfo?.meetsViewportReq ? (
  //                     <Tag color="success">Pass</Tag>
  //                   ) : (
  //                     <Tag color="warning">Fail</Tag>
  //                   )}
  //                 </Space>
  //               </Card>
  //             </Col>

  //             {/* <Col span={24}>
  //               <Card
  //                 size="small"
  //                 style={{
  //                   background: debugInfo?.meetsScaledReq
  //                     ? "#f6ffed"
  //                     : "#fff2e8",
  //                   borderColor: "none",
  //                 }}
  //               >
  //                 <Space>
  //                   {debugInfo?.meetsScaledReq ? (
  //                     <CheckCircleOutlined
  //                       style={{ fontSize: 20, color: "#52c41a" }}
  //                     />
  //                   ) : (
  //                     <CloseCircleOutlined
  //                       style={{ fontSize: 20, color: "#ff7a45" }}
  //                     />
  //                   )}
  //                   <div style={{ flex: 1 }}>
  //                     <div style={{ fontWeight: 600, fontSize: 13 }}>
  //                       Effective Resolution
  //                     </div>
  //                     <div
  //                       style={{ color: "#666", fontSize: 12, marginTop: 4 }}
  //                     >
  //                       Current: {debugInfo?.scaledW} × {debugInfo?.scaledH}{" "}
  //                       pixels
  //                     </div>
  //                     <div style={{ color: "#999", fontSize: 11 }}>
  //                       Required: {debugInfo?.requirements?.scaled.width} ×{" "}
  //                       {debugInfo?.requirements?.scaled.height} pixels
  //                     </div>
  //                   </div>
  //                   {debugInfo?.meetsScaledReq ? (
  //                     <Tag color="success">Pass</Tag>
  //                   ) : (
  //                     <Tag color="warning">Fail</Tag>
  //                   )}
  //                 </Space>
  //               </Card>
  //             </Col> */}

  //             <Col span={24}>
  //               <Card
  //                 size="small"
  //                 style={{
  //                   background: debugInfo?.meetsScreenReq
  //                     ? "#f6ffed"
  //                     : "#fff2e8",
  //                   borderColor: "none",
  //                 }}
  //               >
  //                 <Space>
  //                   {debugInfo?.meetsScreenReq ? (
  //                     <CheckCircleOutlined
  //                       style={{ fontSize: 20, color: "#52c41a" }}
  //                     />
  //                   ) : (
  //                     <CloseCircleOutlined
  //                       style={{ fontSize: 20, color: "#ff7a45" }}
  //                     />
  //                   )}
  //                   <div style={{ flex: 1 }}>
  //                     <div style={{ fontWeight: 600, fontSize: 13 }}>
  //                       {/* <DesktopOutlined style={{ marginRight: 6 }} /> */}
  //                       Screen Resolution
  //                     </div>
  //                     <div
  //                       style={{ color: "#666", fontSize: 12, marginTop: 4 }}
  //                     >
  //                       Current: {debugInfo?.sw} × {debugInfo?.sh} pixels
  //                     </div>
  //                     <div style={{ color: "#999", fontSize: 11 }}>
  //                       Required: {debugInfo?.requirements?.scaled.width} ×{" "}
  //                       {debugInfo?.requirements?.scaled.height} pixels
  //                     </div>
  //                   </div>
  //                   {debugInfo?.meetsScreenReq ? (
  //                     <Tag color="success">Pass</Tag>
  //                   ) : (
  //                     <Tag color="warning">Fail</Tag>
  //                   )}
  //                 </Space>
  //               </Card>
  //             </Col>
  //           </Row>

  //           {/* Suggestions */}
  //           <Card
  //             size="small"
  //             style={{ background: "#fafafa", borderColor: "none" }}
  //           >
  //             <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8 }}>
  //               Suggestions to Fix
  //             </div>
  //             <ul
  //               style={{
  //                 margin: 0,
  //                 paddingLeft: 20,
  //                 fontSize: 12,
  //                 color: "#666",
  //               }}
  //             >
  //               {!debugInfo?.meetsViewportReq && (
  //                 <li>
  //                   Maximize your browser window or use fullscreen mode (F11)
  //                 </li>
  //               )}
  //               {!debugInfo?.meetsScaledReq && (
  //                 <li>
  //                   Reduce display scaling in your system settings (currently{" "}
  //                   {debugInfo?.dpr * 100}%)
  //                 </li>
  //               )}
  //               {!debugInfo?.meetsScreenReq && (
  //                 <li>Use a larger display or increase screen resolution</li>
  //               )}
  //               <li>Reset browser zoom to 100% (Ctrl/Cmd + 0)</li>
  //             </ul>
  //           </Card>
  //         </Space>

  //         <div style={{ textAlign: "center", marginTop: 24 }}>
  //           <Button
  //             type="primary"
  //             size="large"
  //             onClick={() => window.location.reload()}
  //             style={{
  //               backgroundColor: "#BA24D5",
  //               borderColor: "#BA24D5",
  //               borderRadius: 8,
  //               fontWeight: 600,
  //               height: 44,
  //               paddingLeft: 32,
  //               paddingRight: 32,
  //             }}
  //           >
  //             Reload Application
  //           </Button>
  //         </div>
  //       </Card>
  //     </div>
  //   );
  // }

  return (
    <Provider store={store}>
      <MainRoutes />
    </Provider>
  );
}

export default App;
